import api from './api';

const ENDPOINT = 'term-verifications';

const TermVerificationService = {
  get: () => api.get(`${ENDPOINT}/validate`),
  getTerm: () => api.get(`${ENDPOINT}/showTerm`),
  postAccept: () => api.post(`${ENDPOINT}/acceptTerm`),
};

export default TermVerificationService;
